import { render, staticRenderFns } from "./PageOrder.vue?vue&type=template&id=20dee749&scoped=true"
import script from "./PageOrder.vue?vue&type=script&lang=js"
export * from "./PageOrder.vue?vue&type=script&lang=js"
import style0 from "./PageOrder.vue?vue&type=style&index=0&id=20dee749&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dee749",
  null
  
)

export default component.exports